import React from "react"
import Footer from "./Footer.hbd"
import Header from "./Header"

function Layout({ children }) {
  return (
    <React.Fragment>
      <Header />
      <div className="container hbd-content-container main-main">
        {children}
      </div>
      <Footer />
    </React.Fragment>
  )
}

export default Layout
